import { styled } from "@mui/material/styles";
import { Grid } from "../../../Grid";

export const Panel = styled(Grid)`
  background: ${({ theme }) => theme.kinetic.v2.palette.rgb.white};
  color: ${({ theme }) => theme.kinetic.v2.palette.rgb.grayTextDarker};
  min-height: 100%;
  position: relative;
`;
